"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDtoToJSON = exports.UserDtoFromJSONTyped = exports.UserDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function UserDtoFromJSON(json) {
    return UserDtoFromJSONTyped(json, false);
}
exports.UserDtoFromJSON = UserDtoFromJSON;
function UserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'matricola': !runtime_1.exists(json, 'matricola') ? undefined : json['matricola'],
        'codiceFiliale': !runtime_1.exists(json, 'codiceFiliale') ? undefined : json['codiceFiliale'],
        'tipoProfilo': !runtime_1.exists(json, 'tipoProfilo') ? undefined : json['tipoProfilo'],
        'cognome': !runtime_1.exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !runtime_1.exists(json, 'nome') ? undefined : json['nome'],
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
        'tokenAccesso': !runtime_1.exists(json, 'tokenAccesso') ? undefined : json['tokenAccesso'],
        'role': !runtime_1.exists(json, 'role') ? undefined : _1.UserRoleTypeFromJSON(json['role']),
    };
}
exports.UserDtoFromJSONTyped = UserDtoFromJSONTyped;
function UserDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'matricola': value.matricola,
        'codiceFiliale': value.codiceFiliale,
        'tipoProfilo': value.tipoProfilo,
        'cognome': value.cognome,
        'nome': value.nome,
        'tokenAccesso': value.tokenAccesso,
        'role': _1.UserRoleTypeToJSON(value.role),
    };
}
exports.UserDtoToJSON = UserDtoToJSON;
